// extracted by mini-css-extract-plugin
export var locationCard = "_gr-0";